module.exports = __webpack_public_path__ + "img/voda.7af0bfe3.jpg";